//# sourceMappingURL=weaviate.mjs.map
/// <reference types="./weaviate.d.mts" />
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $toast from "../../../redraw_toastify/toastify/toast.mjs";
import * as $weaviate from "../../admin/effects/weaviate.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

export function update(store, msg) {
  if (msg instanceof $msg.ApiErroredMigrations) {
    let org_id = msg.org_id;
    let error = msg.error;
    let _pipe = store.weaviate_migrations;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Errored(error));
    let _pipe$2 = ((_capture) => {
      return $store.set_weaviate_migrations(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedMigrations) {
    let org_id = msg.org_id;
    let migrations = msg.migrations;
    let _pipe = store.weaviate_migrations;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Loaded(migrations));
    let _pipe$2 = ((_capture) => {
      return $store.set_weaviate_migrations(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedCollections) {
    let org_id = msg.org_id;
    let collections = msg.collections;
    let _pipe = store.weaviate_collections;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Loaded(collections));
    let _pipe$2 = ((_capture) => {
      return $store.set_weaviate_collections(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiErroredCollections) {
    let org_id = msg.org_id;
    let error = msg.error;
    let _pipe = store.weaviate_collections;
    let _pipe$1 = $dict.insert(_pipe, org_id, new $remote.Errored(error));
    let _pipe$2 = ((_capture) => {
      return $store.set_weaviate_collections(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else {
    let org_id = msg.org_id;
    return [
      store,
      $effect.batch(
        toList([
          $effect.from(
            (_, _1) => {
              let _pipe = $toast.default_options();
              let _pipe$1 = $toast.type_(_pipe, new $toast.Success());
              return $toast.custom(_pipe$1, "Migration launched successfully.");
            },
          ),
          $weaviate.fetch_migrations(org_id),
        ]),
      ),
    ];
  }
}
